import PaperModal from './PaperModal';
export default PaperModal;
//# sourceMappingURL=index.js.map